import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Button from '../Button/Button.js'

import version from '../../version.js';

import './Footer.css';

class Footer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);
  }

  render(){
    const { dispatch, user, team } = this.props; 
    const state = this.state;

    return (
      <div className="footer section-breaker bg-gradient-inverse">
        <div className="sb-background">
          <img src="/img/herring-bone.png" width="100%"/>
        </div>
        
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-3">
                <h1>
                  <Link to="/" className="list-item brand-font">
                    <span className="brand-space-fix">P</span>attycake
                  </Link>
                </h1>
                <ul className="list-unstyled">
                  <li>
                    <small>
                      made by <a href="https://theschool.studio" target="_blank" rel="noopener noreferrer">School Studio</a> + <a href="https://not.yet.digital" target="_blank" rel="noopener noreferrer">Not Yet Digital</a>
                    </small>
                  </li>
                  <li>
                    <a className="no-underline" href="https://twitter.com/pattycakeio" target="_blank" rel="noopener noreferrer"><i className="fab fa-fw fa-twitter fa-lg"/></a>
                    &nbsp;
                    <a className="no-underline" href="https://instagram.com/pattycakeio" target="_blank" rel="noopener noreferrer"><i className="fab fa-fw fa-instagram fa-lg"/></a>
                    &nbsp;
                    <small className="">
                      v{version}{user.isLoggedIn ? (team.current ? "t" : (user.roles.pro ? "p" : "f")) : "a"}
                    </small>
                  </li>
                </ul>
                <br/>
              </div>
              
              <div className="col-md-2">
                <h4>links</h4>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/pat">Launch Pattycake</Link>
                  </li>
                  <li>
                    <Link to="/at-work">Pattycake at Work</Link>
                  </li>
                  <li>
                    <Link to="/pricing">Pricing</Link>
                  </li>
                  <li>
                    <Link to="/docs">Docs</Link>
                  </li>
                  <li>
                    <Link to="/feature-table">Detailed Feature Table</Link>
                  </li>
                </ul>
                <br/>
              </div>

              <div className="col-md-2">
                <h4>legal</h4>
                <ul className="list-unstyled">
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="/privacy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/tos">Terms of Service</Link>
                  </li>
                </ul>
                <br/>
              </div>

              <div className="col-md-2">
                <h4>company</h4>
                <ul className="list-unstyled">
                  <li>
                    <a href="https://not.yet.digital" target="_blank" rel="noopener noreferrer">Not Yet Digital</a>
                  </li>
                  <li>
                    <a href="https://theschool.studio" target="_blank" rel="noopener noreferrer">School Studio</a>
                  </li>
                  <li>
                    <Link to="/become-a-partner">Become a Partner</Link>
                  </li>
                </ul>
                <br/>
              </div>
              
            </div>
          
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  const { user, team } = state;

  return {
    user, team
  }
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js